import { makeEntityScaffold } from '@classpass/saga-tools';
import { transformV2ClientResponse } from 'helpers/core';

import URLS from 'constants/urls';

const handler = ({ httpClient }) => httpClient.get(URLS.stats.reports.reservations).then(transformV2ClientResponse);

export default makeEntityScaffold('SAGA.API.STATS_REPORTS_RESERVATIONS', handler);
